import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MathText } from "@/components/MathText";

export default function AdminBank() {
    const [rows, setRows] = useState([]);
    useEffect(() => { api.get("/admin/questions?limit=100").then((r) => setRows(r.data)); }, []);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
            <span className="overline text-primary">▮ Vector DB</span>
            <h1 className="mt-2 font-heading font-black text-4xl tracking-tighter">Question bank</h1>
            <p className="mt-2 text-sm text-muted-foreground">Latest 100 questions in the vector store.</p>

            <div className="mt-8 space-y-2">
                {rows.length === 0 && <p className="text-sm text-muted-foreground">Bank is empty. Generate a set to populate it.</p>}
                {rows.map((q) => (
                    <details key={q.id} data-testid={`bank-row-${q.id}`} className="border border-border rounded-sm">
                        <summary className="cursor-pointer p-3 hover:bg-accent/40 flex items-center gap-3 list-none">
                            <span className="font-mono text-xs px-1.5 py-0.5 border border-border rounded-sm">{q.exam}</span>
                            <span className="font-mono text-xs px-1.5 py-0.5 border border-border rounded-sm">{q.subject}</span>
                            <span className="font-mono text-xs px-1.5 py-0.5 border border-border rounded-sm">{q.topic}</span>
                            <span className={`font-mono text-xs px-1.5 py-0.5 rounded-sm ${q.source === "worker" ? "bg-secondary/20 text-secondary" : "bg-muted"}`}>{q.source}</span>
                            <MathText inline className="text-sm truncate flex-1">{q.question}</MathText>
                            <span className="font-mono text-xs text-primary">{q.correct_option}</span>
                        </summary>
                        <div className="border-t border-border p-4 text-sm">
                            <MathText className="mb-3">{q.question}</MathText>
                            <div className="grid grid-cols-2 gap-2 mb-3">
                                {q.options.map((o) => (
                                    <div key={o.key} className={`p-2 border rounded-sm ${o.key === q.correct_option ? "border-green-600 bg-green-500/10" : "border-border"}`}>
                                        <span className="font-mono font-bold mr-2">{o.key}</span><MathText inline>{o.text}</MathText>
                                    </div>
                                ))}
                            </div>
                            {q.explanation && <MathText className="text-xs bg-muted/40 border border-border rounded-sm p-2">{q.explanation}</MathText>}
                        </div>
                    </details>
                ))}
            </div>
        </div>
    );
}
